const itemMovement = {
  bookQuantity: 'Quantité au livre',
  actionNumber: "Numéro d'action",
  container: 'conteneur',
  effectiveDate: 'Date effective',
  from: 'de {{entity}}',
  fromNoOrder: "d'aucune commande",
  fromOrder: 'de la commande {{orderName}}',
  in: 'dans {{entity}}',
  movedQuantity: 'Quantité déplacée',
  movement: 'Mouvement',
  movements: 'Mouvements',
  previously: 'Auparavant',
  timestamp: 'Horodatage',
  to: 'dans {{entity}}',
  toNoOrder: 'vers aucune commande',
  toOrder: 'vers la commande {{orderName}}',
  user: 'Utilisateur',
  breakbulkRelocation: 'Relocalisation partielle de {{from}} vers {{to}}',
  breakbulkOrderTransfert: 'Transfert partiel de la commande {{from}} vers la commande {{to}}',
};

export default itemMovement;
